import styles from "./ReservationDescription.module.scss";
import React, {useState} from "react";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {IClassEventReservation} from "../../../../../models/ClassEventReservation";

interface IReservationDescriptionProps {
    reservation: IClassEventReservation,
    setShowDescriptionReservation: (value: {isOpen: boolean, reservation: IClassEventReservation | null}) => void
}
const ReservationDescription: React.FC<IReservationDescriptionProps> = ({reservation, setShowDescriptionReservation}) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const {t} = useTranslation();

    const handleDescription = () => {
        setIsOpen(!isOpen);
    }

    const getNaming = () => {
        if (reservation.type === "class-event" && reservation.waitingList?.length) {
            return "WaitingList";
        } else if (reservation.type === "class-event") {
            return "Booked";
        } else if (reservation.type === "reservation") {
            return "Appointment";
        } else {
            return "";
        }

    }

    const showBookingCalendarPopup = () => {
        setShowDescriptionReservation({isOpen: true, reservation: reservation})
    }

    return (
        <li className={styles.reservation}>
            <p
                onClick={handleDescription}
                className={`${styles.title} ${styles[getNaming()]}`}
            >
                {t(`${getNaming()}`)}
                {!isOpen && <span className={styles.startTime}>{moment(reservation.occuranceDate).format("h A")}</span>}
            </p>
            <div className={`${styles.descriptionBox} ${isOpen ? styles.open : ""}`}>
                <p className={styles.naming}>{reservation.trainningCourseName}</p>
                <p className={styles.trainer}>{reservation.instructorFirstName} {reservation.instructorLastName}</p>
                <p className={styles.time}>{moment(reservation.occuranceDate).format("hh:mm A")} - {moment(reservation.occuranceDate).add(reservation.duration, "minutes").format("hh:mm A")}</p>
                <span className={styles.seeDetails} onClick={showBookingCalendarPopup}>
                    {t("SeeDetails")}
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.0254 4.94165L17.0837 9.99998L12.0254 15.0583" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2.91699 10H16.942" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </div>
        </li>
    )
}

export default ReservationDescription;